import type * as React from 'react';
import { useToast } from '@chakra-ui/react';

export const useSuccessToaster = () => {
    const toast = useToast();

    const handleSuccess = (msg: React.ReactNode, durationMs: number = 3000) => {
        toast({
            title: 'Success',
            status: 'success',
            duration: durationMs,
            isClosable: true,
            description: msg,
        });
    };

    return {
        handleSuccess,
    };
};
